import { action, makeObservable, observable } from "mobx";

export interface IAboutUsDialogStore {
    isOpen: boolean;

    setOpen(open: boolean);
}

export class AboutUsDialogStore implements IAboutUsDialogStore {
    constructor() {
        makeObservable(this);
    }

    @observable
    public isOpen = false;

    @action
    public setOpen(open): void {
        this.isOpen = open;
    }
}
